import { DBDef_SmartDoc, SmartDocEditorPermissionKeys, SmartDocPermissionKeys } from '@app/advisor-content-shared';
import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
import { PermissionKey_FE } from '@nu-art/permissions-frontend/PermissionKey_FE';
import { ModuleFE_QuaiProtoItem } from '@app/styles';
import { deleteKeysObject } from '@nu-art/ts-common';
export const dispatch_onSmartDocsUpdated = new ThunderDispatcherV3('__onSmartDocsUpdated');
export class ModuleFE_SmartDoc_Class extends ModuleFE_QuaiProtoItem {
    _v1;
    permissions;
    constructor() {
        super(DBDef_SmartDoc, dispatch_onSmartDocsUpdated, {});
        this._v1 = {};
        this.permissions = {
            ui: PermissionKey_FE.generatePermissionKeysByLevels(SmartDocEditorPermissionKeys),
            collection: PermissionKey_FE.generatePermissionKeysByLevels(SmartDocPermissionKeys),
        };
    }
    // ######################## Search ########################
    __searchFilterMapper = (item) => {
        return [item.label];
    };
    __searchGroups = (items, filter) => {
        return [{
                group: this.dbDef.dbKey, results: items.map(item => ({
                    _id: item._id,
                    uiLabel: item.label
                }))
            }];
    };
    // ######################## Internal Logic ########################
    validateInternal(_instance) {
        _instance = deleteKeysObject(_instance, ['_variableIds', '_tagIds', '_templateIds']);
        super.validateInternal(_instance);
    }
}
export const ModuleFE_SmartDoc = new ModuleFE_SmartDoc_Class();
//# sourceMappingURL=ModuleFE_SmartDoc.js.map